<template>
  <div>
    <validation-observer ref="refFormObserver">
      <b-form>
        <b-row>
          <b-col cols="12" lg="6">
            <form-field-text
              id="bosch_name"
              v-model="itemData.name"
              :label="$t('bosch.name')"
              rules="required"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="bosch_panel_host"
              v-model="itemData.panel_host"
              :label="$t('bosch.panelHost')"
              rules="required"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="bosch_panel_passcode"
              v-model="itemData.panel_passcode"
              :label="$t('bosch.panelPasscode')"
              rules="required"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-text
              id="bosch_panel_instance"
              v-model="itemData.panel_instance"
              :label="$t('bosch.panelInstance')"
              rules="required"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-select
              id="bosch_panel_profile"
              v-model="itemData.id_bosch_panel_profile"
              :label="$t('bosch.profile')"
              :options="profileOptions"
              :reduce-option="(val) => val.id"
              option-label="name"
              :clearable="true"
              :description="profileDescription"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-select
              id="bosch_id_facility"
              v-model="itemData.id_unit"
              :label="$t('bosch.units')"
              :options="facilitiesOptions"
              multiple
              taggable
              rules="required"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-select
              id="bosch_id_center"
              v-model="itemData.id_center"
              :label="$t('bosch.center')"
              :options="centerOptions"
              rules="required"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-select
              id="bosch_id_sector"
              v-model="itemData.id_sector"
              :label="$t('bosch.sector')"
              :options="sectorOptions"
              rules="required"
            />
          </b-col>
          <b-col cols="12" lg="6">
            <form-field-select
              id="bosch_id_reseller"
              v-model="itemData.id_omniview_reseller"
              :label="$t('bosch.reseller')"
              :options="resellerOptions"
            />
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </div>
</template>

<script>
import FormFieldText from "@/components/WizardModal/FormFields/FormFieldText.vue";
import FormFieldToggle from "@/components/WizardModal/FormFields/FormFieldToggle.vue";
import FormFieldSelect from "@/components/WizardModal/FormFields/FormFieldSelect.vue";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { useUtils as useI18nUtils } from "@core/libs/i18n";
import formValidation from "@core/comp-functions/forms/form-validation";

export default {
  name: "BoschPanelsGeneralWizard",
  components: {
    FormFieldText,
    FormFieldToggle,
    FormFieldSelect,
    ValidationObserver,
    ValidationProvider,
  },
  props: {
    itemData: {
      type: Object,
      required: true,
    },
    profileOptions: {
      type: Array,
      default: () => [],
    },
    profileLoading: {
      type: Boolean,
      default: false,
    },
    facilitiesOptions: {
      type: Array,
      required: true,
    },
    centerOptions: {
      type: Array,
      required: true,
    },
    sectorOptions: {
      type: Array,
      required: true,
    },
    resellerOptions: {
      type: Array,
      required: true,
    },
  },
  setup(props) {
    const { t } = useI18nUtils();
    const { refFormObserver, getValidationState } = formValidation();

    return {
      t,
      refFormObserver,
      getValidationState,
    };
  },
  computed: {
    profileDescription() {
      if (this.profileLoading) return "Loading profiles...";

      return this.profileOptions.length === 0
        ? "No profiles are available. You can continue without one."
        : "Optional";
    },
  },
};
</script>
